import { bn, bnOrZero } from '@shapeshiftoss/utils';
import { encodeFunctionData, erc20Abi, getAddress } from 'viem';
export const getErc20Data = (to, value, contractAddress) => {
    if (!contractAddress)
        return '';
    return encodeFunctionData({
        abi: erc20Abi,
        functionName: 'transfer',
        args: [getAddress(to), BigInt(value)],
    });
};
export const calcNetworkFeeCryptoBaseUnit = (args) => {
    const { supportsEIP1559, gasLimit, gasPrice, l1GasLimit, l1GasPrice, maxFeePerGas, maxPriorityFeePerGas, } = args;
    // l1 fee if exists or 0
    const l1Fee = bnOrZero(l1GasPrice).times(bnOrZero(l1GasLimit));
    // eip1559 fees
    if (supportsEIP1559 && maxFeePerGas && maxPriorityFeePerGas) {
        return bn(gasLimit).times(maxFeePerGas).plus(l1Fee).toFixed(0);
    }
    // legacy fees
    return bn(gasLimit).times(gasPrice).plus(l1Fee).toFixed(0);
};
export const getFees = async (args) => {
    const { adapter, data, to, value, from, supportsEIP1559 } = args;
    const { average: { chainSpecific: feeData }, } = await adapter.getFeeData({ to, value, chainSpecific: { from, data } });
    const networkFeeCryptoBaseUnit = calcNetworkFeeCryptoBaseUnit({
        ...feeData,
        supportsEIP1559,
    });
    const { gasLimit, gasPrice, maxFeePerGas, maxPriorityFeePerGas } = feeData;
    if (supportsEIP1559 && maxFeePerGas && maxPriorityFeePerGas) {
        return { networkFeeCryptoBaseUnit, gasLimit, maxFeePerGas, maxPriorityFeePerGas };
    }
    return { networkFeeCryptoBaseUnit, gasLimit, gasPrice };
};
